import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import JukoBoxLogo from '../components/JukoBoxLogo';
import PageTransition from '../components/PageTransition';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageTransition>
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Main Content */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', py: { xs: 6, md: 8 } }}>
          <Container maxWidth="sm">
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 5 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0 8px 32px 0 rgba(0,0,0,0.08)',
                bgcolor: 'background.paper',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <JukoBoxLogo size={90} />
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '6rem', md: '8rem' },
                  fontWeight: 'bold',
                  color: 'primary.main',
                  mb: 2,
                  textShadow: '0 0 10px rgba(29, 185, 84, 0.1)',
                }}
              >
                404
              </Typography>
              <Typography variant="h4" sx={{ mb: 2, color: 'text.primary' }}>
                Oups ! Cette page n'existe pas
              </Typography>
              <Typography
                variant="body1"
                sx={{ mb: 4, color: 'text.secondary', maxWidth: '600px' }}
              >
                La page que vous recherchez semble avoir disparu dans les méandres de la musique. Ne
                vous inquiétez pas, vous pouvez toujours revenir à la page d'accueil pour continuer
                à profiter de JukoBox.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate('/')}
                  sx={{
                    borderRadius: '50px',
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    boxShadow: '0 4px 14px 0 rgba(255, 107, 107, 0.2)',
                    '&:hover': {
                      boxShadow: '0 6px 20px 0 rgba(255, 107, 107, 0.3)',
                    },
                  }}
                >
                  Retour à l'accueil
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => navigate(-1)}
                  sx={{
                    borderRadius: '50px',
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    '&:hover': {
                      borderColor: 'primary.dark',
                      backgroundColor: 'rgba(255, 107, 107, 0.05)',
                    },
                  }}
                >
                  Page précédente
                </Button>
              </Box>
            </Paper>
          </Container>
        </Box>
      </Box>
    </PageTransition>
  );
};

export default NotFound;
